export default {
  pageTitle: '肉盛り溶接サービス',
  metaDescription: 'TEFは肉盛り溶接サービスを提供し、機器表面の補修・保護を行うことで、容器やノズルなどのプロセス機器の耐用年数を延ばします。',
  sidebar: {
    title: 'メンテナンス・修繕一覧',
    weldingOverlay: '溶接オーバーレイ',
    patching: 'パッチング',
    piping: '配管',
    reShell: 'リシェル',
    reTubing: 'リチュービング',
  },
  productName: '溶接オーバーレイ',
  subheading: '現地（オンサイト）での肉盛溶接（オーバーレイ）および仕上げ加工サービス',
  paragraph1: '当社は、可搬式の専用機械を使用し、お客様の現場に直接、精密かつ効率的な肉盛溶接（オーバーレイ溶接）および仕上げ加工サービスを提供しています。高品質なオーバーレイ材をお客様のニーズに合わせて施工することで、部品の耐久性と性能を向上させます。',
  paragraph2: '経験豊富な技術者が、補修、表面強化、耐食性向上のいずれの場合でも、円滑な作業遂行を実現します。現地で作業を行うことで、ダウンタイムを最小限に抑え、大型または複雑な設備を輸送する必要をなくします。',
  paragraph3: '高度な溶接・仕上げソリューションを、必要な場所で直接お受けいただける利便性をぜひご体感ください。',
  gallery: {
    overlayNozzle: 'ノズルオーバーレイ',
    machiningSurface: '表面機械加工',
    overlayChannel: 'チャンネルオーバーレイ',
    finishingSurface: '表面仕上げ',
    finishMachiningSurface: '仕上げ機械加工面',
  },
};
